// removed by extract-text-webpack-plugin
module.exports = {"tablist":"tablist","tab":"tab","tabpanels":"tabpanels","tabpanel":"tabpanel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/MediaUpload/Tabs.module.scss
// module id = 694
// module chunks = 0